var _style, _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFairy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 255.1 255.1",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 255.1 255.1"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0Fairy{fill:#fb89eb}.st1Fairy{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 127.6,
    cy: 127.6,
    r: 121.6,
    className: "st0Fairy"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.964,180.088l28.739-8.333l24.822,45.386c0.033,0.059,0.117,0.059,0.149,0l24.822-45.386l28.739,8.333 c0.064,0.019,0.124-0.041,0.105-0.106l-8.334-28.17l44.134-24.138c0.059-0.032,0.059-0.117,0-0.149l-44.498-24.337l8.698-29.4 c0.019-0.064-0.041-0.124-0.105-0.106l-29.413,8.529l-24.148-44.153c-0.032-0.059-0.117-0.059-0.149,0l-24.148,44.153l-29.413-8.529 c-0.064-0.019-0.124,0.041-0.105,0.106l8.698,29.4l-44.498,24.337c-0.059,0.032-0.059,0.117,0,0.149l44.134,24.138l-8.334,28.17 C73.84,180.047,73.9,180.107,73.964,180.088z M96.265,127.91l20.36,11.135l11.135,20.36c0.032,0.059,0.117,0.059,0.149,0 l11.135-20.36l20.36-11.135c0.059-0.032,0.059-0.117,0-0.149l-20.36-11.135l-11.135-20.36c-0.032-0.059-0.117-0.059-0.149,0 l-11.135,20.36l-20.36,11.135C96.207,127.793,96.207,127.877,96.265,127.91z",
    className: "st1Fairy"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairy);
export default __webpack_public_path__ + "static/media/fairy.18bb4fcb0c37dbbe1fb317e84219ef44.svg";
export { ForwardRef as ReactComponent };